import { Component, OnInit } from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {TableViewAbstractComponent} from '../../table-view-abstract/table-view-abstract.component';

@Component({
  selector: 'app-table-column-create-time',
  templateUrl: './table-column-create-time.component.html',
  styleUrls: ['./table-column-create-time.component.css']
})
export class TableColumnCreateTimeComponent extends TableViewAbstractComponent implements OnInit {
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService
  ) {
    super(nzMessageService, taskHttpService);
  }

}
